import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import DatePicker from "react-datepicker";
import isEqual from "date-fns/isEqual";
import isAfter from "date-fns/isAfter";
import isBefore from "date-fns/isBefore";
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  TextareaAutosize,
  TextField,
  Typography,
} from "@common-ui/ui";
import { Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import GroupsIcon from "@mui/icons-material/Groups";
import { updateWorkEvent } from "../../services";

export const EditWorkEventDialog = (props) => {
  const [loading, setLoading] = useState(false);

  const handleDialogClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    props.handleClose();
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      work_order_reference: "",
      purchase_order_reference: "",
      scheduled_start_date: "",
      scheduled_end_date: "",
      notes: "",
    },
    validationSchema: Yup.object({
      work_order_reference: Yup.string().nullable().trim(),
      purchase_order_reference: Yup.string().nullable().trim(),
      scheduled_start_date: Yup.date().nullable(),
      scheduled_end_date: Yup.date().nullable(),
      notes: Yup.string().nullable().trim(),
    }),
    onSubmit: async () => {
      setLoading(true);
      let {
        work_order_reference,
        purchase_order_reference,
        scheduled_start_date,
        scheduled_end_date,
        notes,
      } = formik.values;
      console.log(formik.values);

      const attributes = {
        work_order_reference: work_order_reference,
        purchase_order_reference: purchase_order_reference,
        scheduled_start_date: scheduled_start_date,
        scheduled_end_date: scheduled_end_date,
        notes: notes,
      };
      try {
        await updateWorkEvent(props?.orgId, props?.workEvent?.id, attributes);
        props.getWorkEvents();
        handleDialogClose();
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (props.workEvent && Object.keys(props.workEvent).length > 0) {
      formik.setFieldValue(
        "work_order_reference",
        props.workEvent.work_order_reference
      );
      formik.setFieldValue(
        "purchase_order_reference",
        props.workEvent.purchase_order_reference
      );
      formik.setFieldValue(
        "scheduled_start_date",
        props.workEvent.scheduled_start_date
          ? new Date(props.workEvent.scheduled_start_date)
          : null
      );
      formik.setFieldValue(
        "scheduled_end_date",
        props.workEvent.scheduled_end_date
          ? new Date(props.workEvent.scheduled_end_date)
          : null
      );
      formik.setFieldValue(
        "notes",
        props.workEvent.notes ? props.workEvent.notes : ""
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.workEvent]);

  useEffect(() => {
    if (formik.values.scheduled_end_date === null) {
      formik.setFieldValue(
        "scheduled_end_date",
        formik.values.scheduled_start_date
      );
    } else {
      if (
        isEqual(
          new Date(formik.values.scheduled_start_date),
          new Date(formik.values.scheduled_end_date)
        ) ||
        isAfter(
          new Date(formik.values.scheduled_start_date),
          new Date(formik.values.scheduled_end_date)
        )
      ) {
        formik.setFieldValue(
          "scheduled_end_date",
          formik.values.scheduled_start_date
        );
      } else {
        return;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.scheduled_start_date]);

  useEffect(() => {
    if (
      formik.values.scheduled_end_date &&
      isBefore(
        new Date(formik.values.scheduled_end_date),
        new Date(formik.values.scheduled_start_date)
      )
    ) {
      formik.setFieldValue(
        "scheduled_start_date",
        formik.values.scheduled_end_date
      );
    } else {
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.scheduled_end_date]);

  return (
    <Dialog
      open={props.open}
      onClose={handleDialogClose}
      aria-labelledby="edit-work-event-dialog"
      aria-describedby="edit-work-event-dialog-form"
      scroll="paper"
      PaperProps={{ sx: { bgcolor: "background.paper" } }}
      maxWidth="lg"
    >
      <DialogTitle>
        <Stack sx={{ alignItems: "left" }}>
          <Typography variant="h6">Edit Work Event Information</Typography>
        </Stack>
        {props.open ? (
          <IconButton
            aria-label="close"
            onClick={() => {
              props.handleClose();
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ background: "#F8F8F8" }}>
        <Box
          component="main"
          sx={{
            alignItems: "center",
            display: "flex",
            flexGrow: 1,
            minHeight: "100%",
          }}
        >
          <Grid
            container
            direction="column"
            justifyContent="space-between"
            alignItems="stretch"
            spacing={2}
          >
            <Grid item xs={12}>
              <Grid item xs container direction="column" spacing={2}>
                <Grid item xs={12}>
                  <Grid
                    item
                    xs="auto"
                    container
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ mb: 2 }}
                  >
                    <Grid item xs={4}>
                      <Stack>
                        <Typography sx={{ mt: 1 }} variant="subtitle1">
                          Client:
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid item xs={8}>
                      <Stack direction="row" spacing={0}>
                        <Stack direction="row">
                          <Typography sx={{ mt: 1, mr: 3 }} variant="subtitle1">
                            Owner
                            <TextField
                              style={{ width: 280 }}
                              sx={{ mt: 1 }}
                              size="small"
                              autoComplete="off"
                              fullWidth
                              disabled
                              placeholder="Owner"
                              margin="normal"
                              name="wok"
                              type="text"
                              value={props?.customer?.name}
                              variant="outlined"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <GroupsIcon />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Typography>

                          <Typography sx={{ mt: 1, mr: 3 }} variant="subtitle1">
                            Place
                            <TextField
                              style={{ width: 280 }}
                              sx={{ mt: 1 }}
                              size="small"
                              autoComplete="off"
                              fullWidth
                              disabled
                              placeholder="Place"
                              margin="normal"
                              name="customer_place"
                              type="text"
                              value={props.place ? props.place?.name : ""}
                              variant="outlined"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <LocationOnIcon />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />
                  <Grid
                    item
                    xs
                    container
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ mb: 2 }}
                  >
                    <Grid item xs={4}>
                      <Stack>
                        <Typography sx={{ mt: 1 }} variant="subtitle1">
                          Work Event Details:
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid item xs={8}>
                      <Stack direction="column" spacing={0}>
                        <Stack direction="row">
                          <Typography sx={{ mt: 1, mr: 3 }} variant="subtitle1">
                            Reference Work Order ID
                            <TextField
                              sx={{ mt: 1 }}
                              size="small"
                              autoComplete="off"
                              error={Boolean(
                                formik.touched.work_order_reference &&
                                  formik.errors.work_order_reference
                              )}
                              fullWidth
                              helperText={
                                formik.touched.work_order_reference &&
                                formik.errors.work_order_reference
                              }
                              placeholder="Reference Work Order ID"
                              margin="normal"
                              name="work_order_reference"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              type="text"
                              value={formik.values.work_order_reference}
                              variant="outlined"
                            />
                          </Typography>

                          <Typography sx={{ mt: 1 }} variant="subtitle1">
                            Client Purchase Order
                            <TextField
                              sx={{ mt: 1 }}
                              size="small"
                              autoComplete="off"
                              error={Boolean(
                                formik.touched.purchase_order_reference &&
                                  formik.errors.purchase_order_reference
                              )}
                              fullWidth
                              helperText={
                                formik.touched.purchase_order_reference &&
                                formik.errors.purchase_order_reference
                              }
                              placeholder="Client Purchase Order"
                              margin="normal"
                              name="purchase_order_reference"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              type="text"
                              value={formik.values.purchase_order_reference}
                              variant="outlined"
                            />
                          </Typography>
                        </Stack>
                        <Stack>
                          <Typography sx={{ mt: 1 }} variant="subtitle1">
                            Notes/Comments
                          </Typography>
                          <TextField
                            sx={{ mt: 1 }}
                            size="small"
                            InputProps={{
                              inputComponent: TextareaAutosize,
                              inputProps: { minRows: 4 },
                            }}
                            autoComplete="off"
                            error={Boolean(
                              formik.touched.notes && formik.errors.notes
                            )}
                            fullWidth
                            helperText={
                              formik.touched.notes && formik.errors.notes
                            }
                            placeholder="Notes"
                            margin="normal"
                            name="notes"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            type="text"
                            value={formik.values.notes}
                            variant="outlined"
                          />
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Divider />

                  <Grid
                    item
                    xs
                    container
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ mb: 2 }}
                  >
                    <Grid item xs={4}>
                      <Stack>
                        <Typography sx={{ mt: 1 }} variant="subtitle1">
                          Issuance:
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid item xs={8}>
                      <Stack direction="row" spacing={0}>
                        <Stack direction="row" justifyContent="space-around">
                          <Typography sx={{ mt: 1, mr: 3 }} variant="subtitle1">
                            Scheduled Start Date
                            <DatePicker
                              isClearable
                              showMonthDropdown
                              showYearDropdown
                              todayButton="Today"
                              dropdownMode="select"
                              dateFormat="MM/dd/yyyy"
                              placeholderText="Start date"
                              selected={formik.values.scheduled_start_date}
                              onChange={(date) =>
                                formik.setFieldValue(
                                  "scheduled_start_date",
                                  date
                                )
                              }
                              customInput={
                                <TextField
                                  fullWidth
                                  size="small"
                                  margin="normal"
                                  name="scheduled_start_date"
                                  onBlur={formik.handleBlur}
                                  onChange={formik.handleChange}
                                  // value={formik.values.scheduled_start_date}
                                  error={Boolean(
                                    formik.touched.scheduled_start_date &&
                                      formik.errors.scheduled_start_date
                                  )}
                                  helperText={
                                    formik.touched.scheduled_start_date &&
                                    formik.errors.scheduled_start_date
                                  }
                                  // {...params}
                                />
                              }
                            />
                          </Typography>

                          <Typography sx={{ mt: 1 }} variant="subtitle1">
                            Scheduled End Date
                            <DatePicker
                              isClearable
                              showMonthDropdown
                              showYearDropdown
                              todayButton="Today"
                              dropdownMode="select"
                              dateFormat="MM/dd/yyyy"
                              placeholderText="End date"
                              selected={formik.values.scheduled_end_date}
                              minDate={
                                formik.values.scheduled_start_date ?? null
                              }
                              onChange={(date) =>
                                formik.setFieldValue("scheduled_end_date", date)
                              }
                              customInput={
                                <TextField
                                  fullWidth
                                  size="small"
                                  margin="normal"
                                  name="scheduled_end_date"
                                  onBlur={formik.handleBlur}
                                  onChange={formik.handleChange}
                                  value={formik.values.scheduled_end_date}
                                  error={Boolean(
                                    formik.touched.scheduled_end_date &&
                                      formik.errors.scheduled_end_date
                                  )}
                                  helperText={
                                    formik.touched.scheduled_end_date &&
                                    formik.errors.scheduled_end_date
                                  }
                                  // {...params}
                                />
                              }
                            />
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex" }}>
          <div>
            <Button
              sx={{ mr: 2 }}
              size="large"
              onClick={() => {
                handleDialogClose();
              }}
              variant="outlined"
            >
              Cancel
            </Button>
          </div>
          <div>
            <Button
              color="primary"
              // disabled={isDisabled()}
              size="large"
              onClick={formik.handleSubmit}
              variant="contained"
            >
              {loading && <CircularProgress size={14} color="secondary" />}
              {!loading && "Save"}
            </Button>
          </div>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
